window.handleDownloadCsvFile = function (url) {
  const maxTotalRecords = 5000;
  let totalRecords = $('#totalRecords').val();
  if (totalRecords <= maxTotalRecords) {
    return window.open(url);
  } else {
    return $('#warning-extract-modal').modal('show');
  }
}
